<div class="pagecontent">
    <h1 class="header1">
        <span>Welcome to the Mileage Reimbursement Center.</span>
    </h1>
    <h2 class="header2">
        <span>Please begin by entering the Medicaid Number</span>
    </h2>
    <div formGroupName="tripRequest">
        <div class="consumer-row" >
            <div class="form-field">
                <label for="recipientId">RID <span class="star">*</span></label>
                <mat-form-field appearance="outline">
                    <input id="recipientId" formControlName="recipientId" matInput placeholder="Enter RID" [errorStateMatcher]="matcher" maxlength="10" ridOnly />
                    @if (hasError('recipientId', 'required')) {
                        <mat-error>This field is required.</mat-error>
                    }
                    @else if (hasError('recipientId', 'invalid-rid')) {
                        <mat-error>Invalid RID.</mat-error>
                    }
                    @else if (hasError('recipientId', 'minlength')) {
                        <mat-error>RID must be at least 10 characters long.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-field">
                <label for="firstName">First Name </label>
                <mat-form-field appearance="outline" class="disabled-field">
                    <input id="firstName" matInput placeholder="First Name" readonly formControlName="firstName" />
                </mat-form-field>
            </div>
            <div class="form-field">
                <label for="lastName">Last Name</label>
                <mat-form-field appearance="outline" class="disabled-field">
                    <input id="lastName" matInput placeholder="Last Name" readonly formControlName="lastName" />
                </mat-form-field>
            </div>
            <div class="form-field">
                <label for="middleInitial">Middle Initial</label>
                <mat-form-field appearance="outline" class="disabled-field">
                    <input id="middleInitial" matInput placeholder="Middle Initial" readonly formControlName="middleInitial" />
                </mat-form-field>
            </div>
        </div>
    </div>

</div>